<template>
	<div
		class="module-card"
		:class="{
			'module-card--draft': isDraft,
			'module-card--hidden': isHidden,
			'module-card--dragging': isDragging,
		}"
	>
		<!-- Drag Handle (только для опубликованных модулей) -->
		<div 
			v-if="!isDraft && showDragHandle" 
			class="module-card__drag-handle"
			@mousedown.stop
			@touchstart.stop
			title="Перетащите для изменения порядка"
		>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
				<circle cx="7" cy="5" r="1.5" fill="currentColor"/>
				<circle cx="13" cy="5" r="1.5" fill="currentColor"/>
				<circle cx="7" cy="10" r="1.5" fill="currentColor"/>
				<circle cx="13" cy="10" r="1.5" fill="currentColor"/>
				<circle cx="7" cy="15" r="1.5" fill="currentColor"/>
				<circle cx="13" cy="15" r="1.5" fill="currentColor"/>
			</svg>
		</div>

		<!-- Меню действий -->
		<div class="module-card__menu">
			<button
				type="button"
				class="module-card__menu-button"
				@click="toggleMenu"
				aria-label="Меню действий"
			>
				⋮
			</button>

			<!-- Выпадающее меню -->
			<div v-if="isMenuOpen" class="module-card__dropdown">
				<button
					type="button"
					class="module-card__dropdown-item"
					@click="handleEdit"
				>
					<span class="module-card__dropdown-icon" aria-hidden="true">
						<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M4 20H8L18.5 9.5C19.3 8.7 19.3 7.3 18.5 6.5C17.7 5.7 16.3 5.7 15.5 6.5L5 17V20Z"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path d="M13.5 8.5L16.5 11.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
						</svg>
					</span>
					<span>Редактировать</span>
				</button>

				<button
					type="button"
					class="module-card__dropdown-item"
					@click="handlePreview"
				>
					<span class="module-card__dropdown-icon" aria-hidden="true">
						<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M1.5 12C3.5 7.8 7.3 5 12 5C16.7 5 20.5 7.8 22.5 12C20.5 16.2 16.7 19 12 19C7.3 19 3.5 16.2 1.5 12Z"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<circle
								cx="12"
								cy="12"
								r="3"
								stroke="currentColor"
								stroke-width="1.8"
							/>
						</svg>
					</span>
					<span>Предпросмотр</span>
				</button>

				<button
					v-if="!isDraft"
					type="button"
					class="module-card__dropdown-item"
					@click="handleToggleVisibility"
				>
					<span class="module-card__dropdown-icon" aria-hidden="true">
						<svg
							v-if="isHidden"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1.5 12C3.5 7.8 7.3 5 12 5C16.7 5 20.5 7.8 22.5 12C20.5 16.2 16.7 19 12 19C7.3 19 3.5 16.2 1.5 12Z"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<circle
								cx="12"
								cy="12"
								r="3"
								stroke="currentColor"
								stroke-width="1.8"
							/>
						</svg>
						<svg
							v-else
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M3 4L21 20"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
							/>
							<path
								d="M10.6 6.2C11 6.1 11.5 6 12 6C16.7 6 20.5 8.8 22.5 13C21.9 14.3 21.1 15.4 20.1 16.4"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M17 18.4C15.5 19.1 13.8 19.5 12 19.5C7.3 19.5 3.5 16.7 1.5 12.5C2.3 10.8 3.5 9.3 5 8.2"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M9.9 10.1C9.4 10.6 9 11.3 9 12C9 13.7 10.3 15 12 15C12.7 15 13.4 14.8 13.9 14.4"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
					</span>
					<span>{{ isHidden ? 'Показать' : 'Скрыть' }}</span>
				</button>

				<button
					type="button"
					class="module-card__dropdown-item module-card__dropdown-item--danger"
					@click="handleDelete"
				>
					<span class="module-card__dropdown-icon" aria-hidden="true">
						<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M4 7H20"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
							/>
							<path
								d="M9 3H15"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
							/>
							<path
								d="M7 7L8 20H16L17 7"
								stroke="currentColor"
								stroke-width="1.8"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path d="M10 11V17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
							<path d="M14 11V17" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
						</svg>
					</span>
					<span>Удалить</span>
				</button>
			</div>
		</div>

		<!-- Бейджи -->
		<div v-if="isDraft" class="module-card__badge module-card__badge--draft">
			Черновик
		</div>
		<div v-if="isHidden && !isDraft" class="module-card__badge module-card__badge--hidden">
			Скрыто
		</div>

		<!-- Обложка модуля -->
		<div
			class="module-card__cover"
			:style="{
				backgroundImage: coverImage
					? `url(${coverImage})`
					: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
			}"
		>
			<div class="module-card__cover-overlay"></div>
		</div>

		<!-- Контент -->
		<div class="module-card__content">
			<h3 class="module-card__title">{{ title }}</h3>
			<p v-if="subtitle" class="module-card__subtitle">{{ subtitle }}</p>

			<!-- Информация о публикации -->
			<div v-if="publishInfo" class="module-card__info">
				<span class="module-card__info-label">Публикация:</span>
				{{ publishInfo }}
			</div>
		</div>

		<!-- Модальное окно подтверждения удаления -->
		<Teleport to="body">
					<div
						v-if="showDeleteModal"
						class="delete-modal"
						@click.self="closeDeleteModal"
					>
						<div class="delete-modal__content">
							<h3 class="delete-modal__title">Подтверждение удаления</h3>
							<p class="delete-modal__text">
								Вы уверены, что хотите удалить этот модуль? Это действие нельзя
								отменить.
							</p>
							<div class="delete-modal__actions">
								<button
									type="button"
									class="delete-modal__button delete-modal__button--cancel"
									@click="closeDeleteModal"
								>
									Отменить
								</button>
								<button
									type="button"
									class="delete-modal__button delete-modal__button--delete"
									@click="confirmDelete"
								>
									Удалить
								</button>
							</div>
						</div>
					</div>
		</Teleport>
	</div>
</template>

<script>
export default {
	name: 'ModuleCard',
	props: {
		moduleId: {
			type: [String, Number],
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		subtitle: {
			type: String,
			default: '',
		},
		coverImage: {
			type: String,
			default: '',
		},
		publishInfo: {
			type: String,
			default: '',
		},
		isDraft: {
			type: Boolean,
			default: false,
		},
		isHidden: {
			type: Boolean,
			default: false,
		},
		isDragging: {
			type: Boolean,
			default: false,
		},
		showDragHandle: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['edit', 'preview', 'toggle-visibility', 'delete'],
	data() {
		return {
			isMenuOpen: false,
			showDeleteModal: false,
		}
	},
	methods: {
		toggleMenu() {
			this.isMenuOpen = !this.isMenuOpen
		},
		closeMenu() {
			this.isMenuOpen = false
		},
		handleEdit() {
			this.closeMenu()
			this.$emit('edit', {
				id: this.moduleId,
			})
		},
		handlePreview() {
			this.closeMenu()
			this.$emit('preview', {
				id: this.moduleId,
			})
		},
		handleToggleVisibility() {
			this.closeMenu()
			this.$emit('toggle-visibility', {
				id: this.moduleId,
				isHidden: !this.isHidden,
			})
		},
		handleDelete() {
			this.closeMenu()
			this.showDeleteModal = true
		},
		closeDeleteModal() {
			this.showDeleteModal = false
		},
		confirmDelete() {
			this.$emit('delete', {
				id: this.moduleId,
			})
			this.closeDeleteModal()
		},
		handleClickOutside(event) {
			const menu = this.$el.querySelector('.module-card__menu')
			if (menu && !menu.contains(event.target)) {
				this.closeMenu()
			}
		},
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside)
	},
	beforeUnmount() {
		document.removeEventListener('click', this.handleClickOutside)
	},
}
</script>

<style scoped>
.module-card {
	position: relative;
	background-color: #ffffff;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
	transition: all 0.3s ease;
	display: flex;
	flex-direction: column;
}

/* Hover эффект управляется внешней обёрткой .mcf-draggable-card */
.module-card:hover {
	/* Убрана тень, чтобы избежать "второго подбородка" при drag */
}

/* Состояние перетаскивания */
.module-card--dragging {
	opacity: 1;
	pointer-events: none;
}
 
.module-card--draft {
	border: 2px dashed #9e9e9e;
	background-color: #f9f9f9;
}

.module-card--hidden .module-card__cover,
.module-card--hidden .module-card__content,
.module-card--hidden .module-card__badge {
	opacity: 0.6;
}

/* Drag Handle - скрыт, используется внешний */
.module-card__drag-handle {
	display: none;
}

/* Меню действий */
.module-card__menu {
	position: absolute;
	top: 12px;
	right: 12px;
	z-index: 10;
}

.module-card__menu-button {
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(255, 255, 255, 0.9);
	backdrop-filter: blur(5px);
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 6px;
	font-size: 20px;
	font-weight: 600;
	color: rgba(0, 0, 0, 0.6);
	cursor: pointer;
	transition: all 0.2s ease;
}

.module-card__menu-button:hover {
	background-color: #ffffff;
	color: rgba(0, 0, 0, 0.8);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.module-card__dropdown {
	position: absolute;
	top: 100%;
	right: 0;
	margin-top: 5px;
	background-color: #ffffff;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	min-width: 180px;
	overflow: hidden;
	z-index: 100;
}

.module-card__dropdown-item {
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	padding: 12px 16px;
	background-color: transparent;
	border: none;
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	font-weight: 500;
	color: rgba(0, 0, 0, 0.8);
	text-align: left;
	cursor: pointer;
	transition: background-color 0.2s ease;
}

.module-card__dropdown-item:hover {
	background-color: #f5f5f5;
}

.module-card__dropdown-item--danger {
	color: #f44336;
}

.module-card__dropdown-item--danger:hover {
	background-color: #ffebee;
}

.module-card__dropdown-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
	flex-shrink: 0;
}

.module-card__dropdown-icon svg {
	width: 16px;
	height: 16px;
	display: block;
}

/* Бейджи */
.module-card__badge {
	position: absolute;
	top: 12px;
	left: 12px;
	padding: 6px 12px;
	border-radius: 12px;
	font-family: 'Poppins', Helvetica;
	font-size: 11px;
	font-weight: 700;
	text-transform: uppercase;
	z-index: 5;
	backdrop-filter: blur(5px);
}

.module-card__badge--draft {
	background-color: rgba(255, 152, 0, 0.9);
	color: #ffffff;
}

.module-card__badge--hidden {
	background-color: rgba(158, 158, 158, 0.9);
	color: #ffffff;
}

/* Обложка */
.module-card__cover {
	position: relative;
	width: 100%;
	height: 180px;
	background-size: cover;
	background-position: center;
}

.module-card__cover-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(
		to bottom,
		rgba(0, 0, 0, 0) 0%,
		rgba(0, 0, 0, 0.3) 100%
	);
}

/* Контент */
.module-card__content {
	padding: 16px;
	flex: 1;
	display: flex;
	flex-direction: column;
}

.module-card__title {
	color: #000000;
	font-family: 'Poppins', Helvetica;
	font-size: 18px;
	margin: 0 0 8px 0;
	line-height: 1.3;
}

.module-card__subtitle {
	color: rgba(0, 0, 0, 0.6);
	font-family: 'Poppins', Helvetica;
	font-size: 14px;
	font-weight: 400;
	margin: 0 0 12px 0;
	line-height: 1.4;
}

.module-card__info {
	color: rgba(0, 0, 0, 0.7);
	font-family: 'Poppins', Helvetica;
	font-size: 13px;
	margin-top: auto;
}

.module-card__info-label {
	font-weight: 600;
	color: rgba(0, 0, 0, 0.8);
}

/* Модальное окно удаления - копия из MaterialCard */
.delete-modal {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}

.delete-modal__content {
	background-color: #ffffff;
	border-radius: 12px;
	padding: 30px;
	max-width: 450px;
	width: 90%;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.delete-modal__title {
	font-family: 'Poppins', Helvetica;
	font-size: 22px;
	font-weight: 700;
	color: #000000;
	margin: 0 0 15px 0;
}

.delete-modal__text {
	font-family: 'Poppins', Helvetica;
	font-size: 16px;
	color: rgba(0, 0, 0, 0.7);
	margin: 0 0 25px 0;
	line-height: 1.5;
}

.delete-modal__actions {
	display: flex;
	gap: 12px;
	justify-content: flex-end;
}

.delete-modal__button {
	padding: 12px 24px;
	border: none;
	border-radius: 8px;
	font-family: 'Poppins', Helvetica;
	font-size: 15px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
}

.delete-modal__button--cancel {
	background-color: #f5f5f5;
	color: rgba(0, 0, 0, 0.7);
}

.delete-modal__button--cancel:hover {
	background-color: #e0e0e0;
}

.delete-modal__button--delete {
	background-color: #f44336;
	color: #ffffff;
}

.delete-modal__button--delete:hover {
	background-color: #d32f2f;
	box-shadow: 0 4px 12px rgba(244, 67, 54, 0.3);
}
</style>
